document.addEventListener('DOMContentLoaded', () => {
    const stickyHeaderOffset = 200; // Offset for sticky header
    const links = document.querySelectorAll('.quick-links__link');
    
    if (!links.length) return;

    // Map links to their corresponding sections.
    // This ignores sections that don't have a matching link, 
    const sections = [];
    links.forEach(link => {
        const href = link.getAttribute('href');
        // Check if href exists and is an anchor link
        if (href && href.startsWith('#') && href.length > 1) {
            const sectionId = href.substring(1);
            const sectionEl = document.getElementById(sectionId);
            
            // Only push to our array if the section actually exists in the DOM
            if (sectionEl) {
                sections.push({ link, sectionEl });
            }
        }
    });

    // Function to calculate and update the active link
    function updateActiveLink() {
        let currentActiveLink = null;

        // Loop through our valid sections to find which one is currently in view
        sections.forEach(({ link, sectionEl }) => {
            const rect = sectionEl.getBoundingClientRect();
            
            // If the top of the section is near the sticky header 
            // and the bottom hasn't passed the sticky header yet
            if (rect.top <= stickyHeaderOffset + 50 && rect.bottom > stickyHeaderOffset) {
                currentActiveLink = link;
            }
        });

        // Remove active class from ALL links, then add to the current one.
        // This guarantees NO duplicate active states.
        links.forEach(link => link.classList.remove('is-active'));
        if (currentActiveLink) {
            currentActiveLink.classList.add('is-active');
        }
    }

    let scrollFrame;

    // Use requestAnimationFrame for high-performance scroll handling
    window.addEventListener('scroll', () => {
        if (scrollFrame) {
            window.cancelAnimationFrame(scrollFrame);
        }
        scrollFrame = window.requestAnimationFrame(updateActiveLink);
    });

    // Run once on load to set initial state
    updateActiveLink();
});